import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useCurrentCustomerName, useCurrentSiteId } from "@oculai/planner";
import { onMounted, PropType, ref } from "vue";
import OculaiVideoPlayer from "@/components/other/OculaiVideoPlayer.vue";
import StreamRepository from "@/repositories/StreamRepository";
import logger from "@/services/logger";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveBaseVideo',
  props: {
  cameraId: {
    type: String,
    required: true,
  },
  noSrcMessage: {
    type: String as PropType<string | null>,
    required: false,
  },
  addRightSpaceToControlBar: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {

const videoUrl = ref<string | null>(null);
const loading = ref(false);

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();

const props = __props;

onMounted(() => {
  loading.value = true;
  StreamRepository.loadLiveUrl(currentCustomerName, currentSiteId, props.cameraId)
    .then((url) => {
      videoUrl.value = url;
    })
    .catch((error) => {
      videoUrl.value = null;
      logger.error(error);
    })
    .finally(() => {
      loading.value = false;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OculaiVideoPlayer, {
    loading: loading.value,
    src: videoUrl.value,
    noSrcMessage: __props.noSrcMessage || _ctx.$t('err.no_live_found'),
    hls: true,
    addRightSpaceToControlBar: __props.addRightSpaceToControlBar
  }, null, 8, ["loading", "src", "noSrcMessage", "addRightSpaceToControlBar"]))
}
}

})